import { render, staticRenderFns } from "./ItemAutocomplete.vue?vue&type=template&id=e5ec6dea&scoped=true&"
import script from "./ItemAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ItemAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ec6dea",
  null
  
)

export default component.exports